/*
 * A module to provide save access to browser local/sessionStorage.
 *
 * Handles cases where they are not enabled in the users browser settings.
 */

/**
 * Gets an item from the given storage method, if it exists.
 *
 * @param storage The storage method to search, either `window.sessionStorage` or `window.localStorage`
 * @param key The key to search
 *
 * @returns [True if the storage method is enabled, false otherwise,
 *           The value of the given key]
 */
export function getItem(storage: Storage | null, key: string): [boolean, string | null] {
   if (storage == null) return [false, null];
   return [true, storage.getItem(key)];
}

/**
 * Sets an item in the given storage method, if it exists.
 *
 * @param storage The storage method to use, either `window.sessionStorage` or `window.localStorage`
 * @param key The key to set
 * @param value The value to assign to the given key
 * @returns True if the storage method is enabled, false otherwise
 */
export function setItem(storage: Storage | null, key: string, value: string): boolean {
   if (storage == null) return false;
   storage.setItem(key, value);
   return true;
}

/**
 * Removes the value at the given key from the storage method, if it exists.
 *
 * @param storage The storage method to use, either `window.sessionStorage` or `window.localStorage`
 * @param key The key to remove
 * @returns True if the storage method is enabled, false otherwise
 */
export function removeItem(storage: Storage | null, key: string): boolean {
   if (storage == null) return false;
   storage.removeItem(key);
   return true;
}
